/**
 * 新建日程提醒
 * created By lzy 2020.03.19
 */

'use strict';
angular.module('createNewScheduleModule', []).controller('createNewScheduleCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService', 'modalDialog', 'userInfo', 'schedule',
    function($scope, $modalInstance, $validation, trsHttpService, modalDialog, userInfo, schedule) {
        initStatus();
        initData();
        
        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                type: {
                    '1': '日程提醒',
                    '4': '新闻日历'
                },
                schedule: schedule,
                customConfig: {
                    singleDatePicker: schedule.type === 4, // 是否是单选框
                }
            };
        }

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            if (schedule.id) {
                initEditData();
                $scope.data.title = '编辑' + $scope.data.type[schedule.type];
            } else {
                initNewData();
                $scope.data.title = '新建' + $scope.data.type[schedule.type];
            }
        }

        /**
         * [initEditData description] 编辑时初始换数据
         *
         * @return  {[type]}  [return description]
         */
        function initEditData() {
            getScheduleDetail();
        }

        /**
         * [initNewData description] 信件时初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initNewData() {
            $scope.params = {
                serviceid: 'daily',
                method: 'saveOrUpdate',
                content: '',
                userId: userInfo.ID,
                tenantId: userInfo.TENANTID,
                type: schedule.type
            };
        }

        /**
         * [getScheduleDetail description] 获取日程详细信息
         *
         * @return  {[type]}  [return description]
         */
        function getScheduleDetail() {
            var params = {
                serviceid: 'daily',
                method: 'detail',
                id: schedule.id
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                $scope.params = {
                    id: data.datas.id,
                    content: data.datas.content,
                    startTime: data.datas.starttime,
                    endTime: data.datas.endtime,
                    serviceid: 'daily',
                    method: 'saveOrUpdate',
                    userId: userInfo.ID,
                    tenantId: userInfo.TENANTID,
                    type: data.datas.type
                };
            });
        }

        $scope.confirm = function() {
            $scope.dateReminderForm.$pending = {};
            $validation.validate($scope.dateReminderForm).success(function() {
                schedule.type === 4 ? $scope.params.endTime = $scope.params.startTime : '';
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), $scope.params, 'post').then(function(data) {
                    modalDialog.alertType('', data.msg, 'success', false);
                    $modalInstance.close();
                });
            });
        };

        $scope.close = function() {
            $modalInstance.dismiss();
        };
    }
]);
